// src/composables/useMessages.ts
import { ref } from 'vue'
import useGatewayApi from '@/composables/useGatewayApi'

const api = useGatewayApi()

const undirritunNotify = ref(false)
const undirritunNotifyModel = ref<any[]>([])
const messages = ref<any[]>([])

export function useMessages() {
  async function loadMessages() {
    try {
      const res = await api.get('api/v1/core/messages')
      messages.value = res.data ?? []
    } catch (e) {
      console.error('Failed to load messages:', e)
    }
  }

  // Fetch co-signing notifications 
  async function loadSignatureNotifications() {
    try {
      const res = await api.get('api/v1/core/messages/undirritunnotify')

      // res IS the array, not res.data
      undirritunNotifyModel.value = Array.isArray(res) ? res : []

      undirritunNotify.value = undirritunNotifyModel.value.length > 0

    } catch (e) {
      console.error('Failed to load signature notifications:', e)
    }
  }

  return {
    messages,
    undirritunNotify,
    undirritunNotifyModel,

    loadMessages,
    loadSignatureNotifications
  }
}
